import React from "react";
import { Admin, Resource, ListGuesser } from "react-admin";
import {
  ProductList,
  ProductEdit,
  ProductCreate,
  ProductShow,
} from "./products";
import {
  CustomerList,
  CustomerEdit,
  CustomerCreate,
  CustomerShow,
} from "./customers";
import dataProvider from "./dataProvider";
import authProvider from "./authProvider";

import { theme } from "./theme";

function App() {
  return (
    <div className="App">
      <Admin
        authProvider={authProvider}
        dataProvider={dataProvider}
        theme={theme}
      >
        <Resource
          name="products"
          list={ProductList}
          edit={ProductEdit}
          create={ProductCreate}
          show={ProductShow}
        />
        <Resource
          name="customers"
          list={CustomerList}
          edit={CustomerEdit}
          create={CustomerCreate}
          show={CustomerShow}
        />
      </Admin>
    </div>
  );
}

export default App;
